export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="card"><p className="text-gray-500">NotFound — coming in a future phase</p></div>
    </div>
  )
}
